module Meevo.Components.Common {

    interface alertWinInterface {
        (x: number, storenNumber: string, receiptPrinter: string): void;
    }

    interface printNormalInterface {
        (x: string): void;
    }
    interface finishReceiptInterface {
        (): void;
    }

    declare var startReceipt: alertWinInterface;
    declare var printNormal: printNormalInterface;
    declare var finishReceipt: finishReceiptInterface;

    export class JcpPrintService implements IPrintService {
        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $q: angular.IQService) {
        }

        private selectedPrinter: IPrintServicePrinter;

        private printerList = [
            { id: 381, brandId: 0, displayName: "381" },
            { id: 382, brandId: 0, displayName: "382" },
            { id: 383, brandId: 0, displayName: "383" },
            { id: 384, brandId: 0, displayName: "384" },
            { id: 385, brandId: 0, displayName: "385" },
            { id: 386, brandId: 0, displayName: "386" },
            { id: 387, brandId: 0, displayName: "387" },
            { id: 388, brandId: 0, displayName: "388" },
            { id: 389, brandId: 0, displayName: "389" }
        ];

        /* Getter and Setter */
        public getPrinterList(): angular.IPromise<IPrintServicePrinter[]> {
            return this.$q.resolve(this.printerList);
        }

        public getSelectedPrinter(): angular.IPromise<IPrintServicePrinter> {
            if (this.selectedPrinter) {
                return this.$q.resolve(this.selectedPrinter);
            }

            var selectedPrinterId = localStorage.getItem("receiptPrinter");
            if (!selectedPrinterId) {
                return null;
            }

            this.selectedPrinter = _.findWhere(this.printerList, { id: selectedPrinterId }) || null;
            return this.$q.resolve(this.selectedPrinter);
        }

        public setSelectedPrinter(printer: IPrintServicePrinter): angular.IPromise<void> {
            if (printer && printer.id) {
                this.selectedPrinter = _.findWhere(this.printerList, { id: printer.id }) || this.selectedPrinter;
                if (this.selectedPrinter) {
                    localStorage.setItem("receiptPrinter", this.selectedPrinter.id);
                }
            }
            return this.$q.resolve();
        }

        public setSelectedTerminal(terminal: Meevo.Model.MerchantTerminal): angular.IPromise<void> {
            return this.$q.resolve();
        }

        /* Print methods */
        public print(...documentUrls: string[]): angular.IPromise<any> {

            if (!this.selectedPrinter) {
                return this.modalService.alert("Please choose a receipt printer").then(() => { return null; });
            }

            return this.$q.all(documentUrls.map(url => this.dataService.customMethodData(url, "GET", null, { "format": "opos" })))
                .then(responses => responses.forEach(response => this.printContent(response.data)));
        }

        public printToDevice(printerDetail: IPrintServicePrinter, ...documentUrls: string[]): angular.IPromise<any> {
            return this.$q.resolve(null);
        }

        public printCustom(...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {

            if (!this.selectedPrinter) {
                return this.modalService.alert("Please choose a receipt printer").then(() => { return null; });
            }

            return this.$q.all(requestObjs.map(requestObj => {
                requestObj.params = requestObj.params || {};
                requestObj.params["format"] = "opos";

                return this.dataService.customMethodData(requestObj.url, requestObj.method, requestObj.data, requestObj.params);
            })).then(responses => responses.forEach(response => this.printContent(response.data)));
        }

        public printCustomToDevice(printerDetail: IPrintServicePrinter, ...requestObjs: IHttpRequestObject[]): angular.IPromise<any> {
            return this.$q.resolve(null);
        }

        private printContent(content): void {
            try {
                startReceipt(2, this.identityService.current().storeNumber, this.selectedPrinter.id);
                printNormal(content);
                finishReceipt();
            } catch (e) {
                console.log(content);
            }
        }

        public showStandbyMessage() {}
        public queueMessagesToPoleDisplay(lockCallback?: () => angular.IPromise<boolean>, ...messages: Meevo.Components.Common.IPoleDisplayObject[]): void {  }
        public queueMessagesToPoleDisplayToDevice(printerDetail: IPrintServicePrinter, lockCallback?: () => angular.IPromise<boolean>, ...messages: Meevo.Components.Common.IPoleDisplayObject[]): void {  }
        public resetPoleDisplay(printerDetail?: IPrintServicePrinter): angular.IPromise<any> { return this.$q.resolve(); }
        public openDrawer(printerDetail?: IPrintServicePrinter): angular.IPromise<any> { return this.$q.resolve(); }


        static factory(): Function {
            let svc = (dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                identityService: Meevo.Components.Common.IIdentityService,
                $q: angular.IQService) => {
                return new JcpPrintService(dataService, modalService, identityService, $q);
            }

            svc.$inject = ["meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                "meevo.components.common.IdentityService",
                "$q"];

            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.JcpPrintService", JcpPrintService.factory());
}